import { Venue as GQLItem } from '../../generated/graphql';
import { Address } from '../Address';
import { take } from '../../util';

export type Venue = {
  id: number;
  name: string;
  currency: string;
  locale: string;
  timezone: string;
  address?: Address.Address;
};

export const fromGql = (item: GQLItem): Venue => ({
  ...take<Venue>(item, 'id', 'name', 'currency', 'locale', 'timezone'),
  address: item.address ? Address.fromGQL(item.address) : undefined,
});
